import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContractState } from './contract.state';

const selectContractSelector = createFeatureSelector<ContractState>('contract');

// Contract
export const selectAllContractsState = createSelector(
  selectContractSelector,
  state => state.contracts
);

export const selectIsContractLoadingState = createSelector(
  selectContractSelector,
  state => state.loading
);
export const selectCurrentContractState = createSelector(
  selectContractSelector,
  state => state.currentContract
);
export const selectAddedContractIdState = createSelector(
  selectContractSelector,
  state => state.addedContractId
);
export const selectPopUpTitleState = createSelector(
  selectContractSelector,
  state => state.popupTitle
);

// Contract Group Types
export const selectAllContractGroupTypesState = createSelector(
  selectContractSelector,
  state => state.contractGroupTypes
);

// Contract Programs
export const selectAllContractProgramsState = createSelector(
  selectContractSelector,
  state => state.contractPrograms
);

// Contract Capture Types
export const selectContractCaptureTypes = createSelector(
  selectContractSelector,
  state => state.contractCaptureTypes
);

// Contract Flight Card Components
export const selectContractFlightCardComponents = createSelector(
  selectContractSelector,
  state => state.currentContractFlightCardComponents
);

export const selectSysFlightCardComponents = createSelector(
  selectContractSelector,
  state => state.sysFlightCardComponents
);

export const selectSysFlightCardComponentTypes = createSelector(
  selectContractSelector,
  state => state.sysFlightCardComponentTypes
);

export const selectRateEscalationTypes = createSelector(
  selectContractSelector,
  state => state.rateEscalationTypes
);

export const selectContractBillingEntities = createSelector(
  selectContractSelector,
  state => state.contractBillingEntities
);

export const selectContractEntities = createSelector(
  selectContractSelector,
  state => state.contractEntities
);

// Admin Staff
export const selectAdminStaffs = createSelector(selectContractSelector, state => state.adminStaffs);

// Sys Contract Statuses
export const selectSysContractStatuses = createSelector(
  selectContractSelector,
  state => state.sysContractStatuses
);

// Sys Contract Status Change Reasons
export const selectSysContractStatusChangeReasons = createSelector(
  selectContractSelector,
  state => state.sysContractStatusChangeReasons
);

export const selectAllContractTransfers = createSelector(
  selectContractSelector,
  state => state.contractTransfers
);

export const selectContractTransfersLoading = createSelector(
  selectContractSelector,
  state => state.loading
);

export const selectSysClientReportTypes = createSelector(
  selectContractSelector,
  state => state.sysClientReportTypes
);

export const selectProductsList = createSelector(selectContractSelector, state => state.products);

export const selectContractProducts = createSelector(
  selectContractSelector,
  state => state.contractProducts
);

export const selectContractProductsAndProductsList = createSelector(
  selectContractSelector,
  state => ({ products: state.products, contractProducts: state.contractProducts })
);

export const selectAllContractGroupingAnalyticsState = createSelector(
  selectContractSelector,
  state => state.contractGroupingAnalytics
);

export const selectContractProductShortNames = createSelector(
  selectContractSelector,
  state => state.contractProductShortNames
);

export const selectIsCurrentContractTransferable = createSelector(
  selectCurrentContractState,
  contract => contract?.isTransferable ?? false
);

export const selectCurrentContractNextFlightCard = createSelector(
  selectContractSelector,
  state => state?.nextFlightCards ?? []
);

export const selectAdminStaffForRegionalSalesManager = createSelector(
  selectContractSelector,
  state => state.regionalSaleManagerStaffs
);
